<script setup>
import PrimaryButton from "../../../../frontend/src/components/ui/PrimaryButton.vue";
import {computed, reactive, ref} from "vue";
import useForm from "@/composables/useForm";
import marketSectorsService from "@/services/market-sectors.service";

const emit = defineEmits(['saved']);

const form = reactive({
    name: "",
})

const {populateForm, resetForm, flatErrors, setErrors, clearErrors} = useForm(form);
const showModal = ref(false);
const id = ref(null);
const loading = ref(false);

const canSave = computed(() => form.name.length);

async function getData() {
    const {data} = await marketSectorsService.getEdit(id.value);
    populateForm(data);
}

async function save() {
    loading.value = true;
    clearErrors();

    try {
        const {data} = await marketSectorsService.save(id.value, form);

        if (!Object.keys(data.errors).length) {
            showModal.value = false;
            emit('saved');
        } else {
            setErrors(data.errors);
        }
    } finally {
        loading.value = false;
    }
}

function open(itemId) {
    resetForm();
    clearErrors();

    if (itemId) {
        id.value = itemId;
        getData();
    } else {
        id.value = 0;
    }

    showModal.value = true;
}

defineExpose({open});
</script>

<template>
    <b-modal v-model="showModal" modal-class="modal-w-md" :title="(id ? 'Edit' : 'Add') + ' Sector'">
        <form class="form pb-5">
            <template v-if="flatErrors.length">
                <div class="form__error" v-for="(error, index) in flatErrors" :key="index">{{error}}</div>
            </template>

            <div class="form__item">
                <h5 class="heading5 heading5--secondary">Name *</h5>
                <input class="form-control--mid form-control" type="text" v-model="form.name">
            </div>
        </form>

        <template #modal-footer>
            <PrimaryButton
                :disabled="!canSave"
                :loading="loading"
                @click="save"
            />
        </template>
    </b-modal>
</template>

<style scoped>

</style>
